import React, { useMemo } from 'react';
import RoleBasedRoute, { RoleBasedRouteProps } from './RoleBasedRoute';
import { findPathToPage } from './sitemap';
import { PathContext } from './usePathContext';
import { RouteV2Id } from './routesConfigV2';

export interface PathfinderRouteProps extends RoleBasedRouteProps {
  pathPageId: RouteV2Id;
}

/*
 * PathfinderRouter will create a breadcrumb path for the given pageId. The reason for
 * keeping this logic here and now further in the Breadcrumbs component to do it once per
 * render.
 */
const PathfinderRoute: React.FC<PathfinderRouteProps> = ({ pathPageId, ...rest }) => {
  const path = useMemo(() => findPathToPage(pathPageId), [pathPageId]);
  return (
    <PathContext.Provider value={path}>
      <RoleBasedRoute {...rest} />
    </PathContext.Provider>
  );
};

export default PathfinderRoute;
